import can from '@get-bridge/learn-legacy-shared/dist/utils/can';
import isFeatureEnabled from '@get-bridge/learn-legacy-shared/dist/utils/isFeatureEnabled';
import { isRootAccount } from '@get-bridge/learn-legacy-shared/dist/utils/accountConfig';

export default {
  courses: (hosts, authorOnRuntime) => {
    const host = authorOnRuntime ? hosts.perform : hosts.learn;
    return !!host && can('course_template_view') && {
      id: 'SECONDARY_AUTHOR_COURSES',
      host,
      href: '/author/courses',
      otherHrefs: ['/author/courses/.*'],
      name: I18n.t('Courses'),
    }
  },
  programs: (hosts, authorOnRuntime) => {
    const host = authorOnRuntime ? hosts.perform : hosts.learn;
    return !!host && can('program_view') && {
      id: 'SECONDARY_AUTHOR_PROGRAMS',
      host,
      href: '/author/programs',
      otherHrefs: ['/author/programs/.*'],
      name: I18n.t('Programs'),
    }
  },
  liveTrainings: (hosts, authorOnRuntime) => {
    const host = authorOnRuntime ? hosts.perform : hosts.learn;
    return !!host && can('live_course_view') && {
      id: 'SECONDARY_AUTHOR_LIVE_TRAININGS',
      host,
      href: '/author/training',
      otherHrefs: ['/author/training/.*'],
      name: I18n.t('Live Trainings'),
    }
  },
  surveys: (hosts, authorOnRuntime) => {
    const host = authorOnRuntime ? hosts.perform : hosts.learn;
    return !!host && can('survey_view') && {
      id: 'SECONDARY_AUTHOR_SURVEYS',
      host,
      href: '/author/surveys',
      otherHrefs: ['/author/surveys/.*'],
      name: I18n.t('Surveys'),
    }
  },
  checkpoints: (hosts, authorOnRuntime) => {
    const host = authorOnRuntime ? hosts.perform : hosts.learn;
    return !!host && can('task_view') && {
      id: 'SECONDARY_AUTHOR_CHECKPOINTS',
      host,
      href: '/author/checkpoints',
      otherHrefs: ['/author/checkpoints/.*'],
      name: I18n.t('Checkpoints'),
    }
  },
  journeys: hosts =>
    hosts.perform &&
    isFeatureEnabled('journeys_mvp') &&
    can('journey_view') &&
    (isRootAccount() || isFeatureEnabled('journeys_subaccount_support')) && {
      id: 'SECONDARY_AUTHOR_JOURNEYS',
      host: hosts.perform,
      href: '/author/journeys',
      otherHrefs: ['/author/journeys/.*'],
      name: I18n.t('Journeys'),
    },
};



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/utils/buildAtlasLinks/primaryLinks/author.js